var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradeBulwark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 413.85 413.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f4f17d;\n      }\n\n      .cls-2 {\n        opacity: .4;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.3,343.51c-30.11,30.11-68.64,48.75-110.28,53.72l16.62,16.62c13.45-2.77,26.61-6.86,39.38-12.26,25.15-10.64,47.73-25.86,67.12-45.25,19.39-19.39,34.61-41.97,45.25-67.12,5.53-13.08,9.69-26.57,12.47-40.37l-16.7-16.7c-4.78,42.05-23.47,80.99-53.84,111.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M164.99,0c-13.8,2.77-27.29,6.93-40.37,12.47-25.15,10.64-47.73,25.86-67.12,45.25-19.39,19.39-34.61,41.97-45.25,67.12-5.4,12.77-9.49,25.92-12.26,39.38l16.61,16.61c4.97-41.64,23.61-80.17,53.72-110.28,30.37-30.37,69.31-49.06,111.36-53.84L164.99,0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeBulwark);
export default __webpack_public_path__ + "static/media/upgrade-bulwark.144e7019db8b80dd073ab7eed5018caf.svg";
export { ForwardRef as ReactComponent };